export default function FormHelperText({ children }) {
  return <div className="text-sm text-neutral-600">{children}</div>;
}
